import RouterLink from "../Link/RouterLink";
import "./Header.css";
import { header_logo, page_logo_decoration } from "../../Imgs/images";

interface HeaderProps {
  additionalClass?: string;
}

function Header(props: Readonly<HeaderProps>) {
  const burgerClick = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    const mobileMenu = document.getElementById("mobile-menu");

    if (e.currentTarget.classList.contains("active")) {
      mobileMenu?.classList.remove("active");
      e.currentTarget.classList.remove("active");
    } else {
      mobileMenu?.classList.add("active");
      e.currentTarget.classList.add("active");
    }
  };

  // const getHeaderClasses = () => {
  //   let defaultClasses = "main-header";

  //   if (props?.additionalClass)
  //     defaultClasses += ` ${props.additionalClass}-header`;

  //   return defaultClasses;
  // };

  return (
    <header className="main-header">
      <div className="header-row">
        <RouterLink to="/">
          <picture className="header-logo">
            <source srcSet={header_logo} />
            <img src={header_logo} alt="spenseignement-logo" />
          </picture>
        </RouterLink>
        <div className="header-links">
          <RouterLink to="/entreprise" className="header-link">
            <span>Qui sommes-nous</span>
          </RouterLink>
          <RouterLink to="/formation" className="header-link">
            <span>Formations</span>
          </RouterLink>
          {/* <RouterLink to="/supervision" className="header-link">
            <span>Supervision</span>
          </RouterLink>
          <RouterLink to="/service-entreprises" className="header-link">
            <span>Services aux entreprises</span>
          </RouterLink>
          <RouterLink to="/actualites" className="header-link">
            <span>Actualités</span>
          </RouterLink> */}
          <RouterLink to="/contact" className="header-link">
            <span>Nous contacter</span>
          </RouterLink>
        </div>
        <button
          className="header-burger"
          id="burger"
          onClick={burgerClick}
          type="button"
        >
          <span className="burger-top-line burger-line"></span>
          <span className="burger-center-line burger-line"></span>
          <span className="burger-bottom-line burger-line"></span>
        </button>
      </div>
      <div className="header-body" id="mobile-menu">
        <div className="header-ul">
          <RouterLink to="/entreprise" className="header-link-mobile">
            Qui sommes-nous ?
          </RouterLink>
          <RouterLink to="/formation" className="header-link-mobile">
            Formations
          </RouterLink>
          {/* <RouterLink to="/supervision" className="header-link-mobile">
            Supervision
          </RouterLink>
          <RouterLink to="/service-entreprises" className="header-link-mobile">
            Service aux entreprises
          </RouterLink> */}
          {/* <RouterLink to="/actualites" className="header-link-mobile">
            Actualités
          </RouterLink> */}
          <RouterLink to="/contact" className="header-link-mobile">
            Nous contacter
          </RouterLink>
          <picture className="header-icon">
            <source srcSet={page_logo_decoration} />
            <img src={page_logo_decoration} alt="triangle-icon" />
          </picture>
        </div>
      </div>
    </header>
  );
}

export default Header;
